
export default {
  name: 'TabContent',

  data: function () {
    let activeContent = '';
    if (this.product?.description) {
      activeContent = 'description';
    }
/*    if (this.product?.description) {
      activeContent = 'suitable-for-auto';
    }*/
    if (!this.product?.description && this.$store.state.appState?.vars?.['CMS PAGE ID для товара (Отзывы на Яндексе)']) {
      activeContent = 'ya-otzyvy';
    }
    if (!this.product?.description && this.$store.state.appState?.vars?.['CMS PAGE ID для товара (Условия оплаты и доставка)']) {
      activeContent = 'terms-payment-delivery';
    }

    return {
      activeContent: activeContent,
    };
  },

  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    tabs: function () {
      const list = [
        { title: 'Характеристики', value: 'characteristics' },
        { title: 'Наличие', value: 'availability' },
//        { title: 'Подходит к авто', value: 'suitable-for-auto' },
      ];
     // if (this.product.category.name == 'Диски' || this.product.category.name == 'Шины') {
        list.unshift({ title: 'Описание', value: 'description' });
     //   console.log('desc',this.product);
     // }
      if (this.product.category.name == 'Шины') {
        list.push({ title: 'Подходит к авто', value: 'suitable-for-auto' });
      }
      if (this.cmsPageDeliveryPayment) {
        list.push({ title: 'Условия оплаты и доставка', value: 'terms-payment-delivery' });
      }
      if (this.cmsPageYaOtzyvy) {
        list.push({ title: 'Отзывы на Яндексе', value: 'ya-otzyvy' });
      }
      return list;
    },

    productBrand: function () {
      return this.product?.brand?.name || '';
    },
    productQuantity: function () {
      return this.product?.quantity || 0;
    },
    productCharacteristics: function () {
      const slugsLink = ['width', 'height', 'diameter'];
      const slugsHidden = ['nalicie-tovara'];
      const catalogFilterLink = [(this.product?.categories || []).map((t) => t.slug)?.join('/'), 'f'];

      let characteristics = [];
      (this.product?.characteristics || []).map((t) => {
        characteristics.push(...(t?.characteristics || []));
      });
      characteristics = characteristics.filter((t) => t.showInProduct);
      characteristics = characteristics.filter((t) => !slugsHidden.includes(t.slug));
      characteristics = characteristics.map((characteristic) => {
        const item = {
          ...characteristic,
          values: (characteristic?.values || []).map((t) => ({
            ...t,
            value: [t.value, characteristic.unit].filter((t) => !!t).join(' '),
          })),
        };
        if (item.slug === 'tiporazmer') {
          const variantFilterSlug = [
            Boolean(characteristics.find((t) => t.slug === 'width')) && `width=${characteristics.find((t) => t.slug === 'width')?.values?.[0]?.slug}`,
            Boolean(characteristics.find((t) => t.slug === 'height')) && `height=${characteristics.find((t) => t.slug === 'height')?.values?.[0]?.slug}`,
            Boolean(characteristics.find((t) => t.slug === 'diameter')) && `diameter=${characteristics.find((t) => t.slug === 'diameter')?.values?.[0]?.slug}`,
          ].filter((t) => !!t).join('/');
          item.link = `/${[...catalogFilterLink, variantFilterSlug].join('/')}`;
        }
        if (slugsLink.includes(item.slug)) {
          item.link = `/${[...catalogFilterLink, `${item.slug}=${item?.values?.[0]?.slug}`].join('/')}`;
        }

        return item;
      });

      return characteristics;
    },
    productDescription: function () {
      let mess = '<p>'+ this.product.category.name + ' <b>'+this.product.name +'</b> вы можете купить в городе Екатеринбург, Свердловская область с самовывозом по адресу ул. Старых Большевиков, 1</p>\n' +
          '        <p>У нас Вы можете приобрести колеса и сразу поставить на машину. А наши профессиональные менеджеры помогут Вам с выбором.</p>';
      let message = this.product?.description + mess;

      // <br>\n
      for (let i1 = 0; i1 <= message.split('<br>\\n').length; i1++) {
        message = message.replace('<br>\\n', '<br/>');
      }

      // \r\n
      for (let i2 = 0; i2 <= message.split('\\r\\n').length; i2++) {
        message = message.replace('\\r\\n', '<br/>');
      }

      // \t
      for (let i3 = 0; i3 <= message.split('\\t').length; i3++) {
        message = message.replace('\\t', '&nbsp;');
      }

      // \n
      for (let i4 = 0; i4 <= (message.split('\\n').length + 2); i4++) {
        message = message.replace('\\n', '<br/>');
      }

      return message;
    },

    cmsPageDeliveryPayment: function () {
      return this.$store.state.appState?.vars?.['CMS PAGE ID для товара (Условия оплаты и доставка)'];
    },

    cmsPageYaOtzyvy: function () {
      // console.log('otzyvy',this.$store.state.appState?.vars?.['CMS PAGE ID для товара (Отзывы на Яндексе)']);
      return this.$store.state.appState?.vars?.['CMS PAGE ID для товара (Отзывы на Яндексе)'];
    },
  },

  components: {
    TabSuitableForAuto: () => import('~/components/product/tabs/TabSuitableForAuto'),
  },

  methods: {
    changeActiveTab: function (tab) {
      this.activeContent = tab.value;
    },
  },
};
